export default {
    title: 'Connexion',
    intro: "Accédez à notre plateforme de génération de FDES spécifiques avec votre compte.",
    reset_password: 'Réinitialiser le mot de passe',
    submit_button: 'Connexion',
    register_button: 'Créer un compte'
}